export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function downloadCard(url, filename) {
  const res = await fetch(url);
  if (!res.ok) throw new Error("card failed");
  const blob = await res.blob();
  const objUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objUrl);
}

// Native share sheet (WhatsApp/Instagram/Messages on mobile). Returns 'shared' | 'downloaded' | 'cancelled'.
export async function shareCard(url, filename, text) {
  const res = await fetch(url);
  if (!res.ok) throw new Error("card failed");
  const blob = await res.blob();
  const file = new File([blob], filename, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: "AskYeshua", text });
      return "shared";
    } catch (e) {
      if (e && e.name === "AbortError") return "cancelled";
      // any other share failure: fall through to download
    }
  }
  const objUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objUrl);
  return "downloaded";
}
// handlers: { onMeta(id), onBuffer(fullText), onDone(answer), onError(msg) }
export async function streamAsk(question, handlers) {
  const res = await fetch(`${API}/ask/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ question }),
  });
  if (!res.ok || !res.body) {
    handlers.onError?.("The answer could not be revealed. Please try again.");
    return;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let sseBuf = "";
  let textBuf = "";

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    sseBuf += decoder.decode(value, { stream: true });
    const events = sseBuf.split("\n\n");
    sseBuf = events.pop() || "";
    for (const ev of events) {
      const line = ev.split("\n").find((l) => l.startsWith("data: "));
      if (!line) continue;
      let payload;
      try {
        payload = JSON.parse(line.slice(6));
      } catch {
        continue;
      }
      if (payload.type === "meta") handlers.onMeta?.(payload.id);
      else if (payload.type === "delta") {
        textBuf += payload.text;
        handlers.onBuffer?.(textBuf);
      } else if (payload.type === "done") handlers.onDone?.(payload.answer);
      else if (payload.type === "error") handlers.onError?.(payload.message);
    }
  }
}
